import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = rad. */
export const ANGLE_PIVOT: Record<string, number> = {
  rad: 1,
  deg: Math.PI / 180,
  mrad: 0.001,
};

export const transformAngle = createPivotTransformer(ANGLE_PIVOT);
